<mat-list dense
  [sortablejs]="items"
  [sortablejsOptions]="sortableOptions"
  class="sortable-items">
  <mat-list-item *ngFor="let item of items">
    <mat-icon>drag_handle</mat-icon> {{ item.item.name }}
    <mat-divider></mat-divider>
  </mat-list-item>

</mat-list>